import React, { PureComponent } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import {
    Segment
} from 'semantic-ui-react'
import PropTypes from 'prop-types'

class ShipSumChart extends PureComponent {
    render() {
        return (
            <div className="row" style={{marginTop: 25}}>
                <div className="col-md-12">
                    <Segment>
                        <LineChart
                            width={1200}
                            height={300}
                            data={this.props.data.lines}
                            margin={{
                            top: 5, right: 30, left: 20, bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                {this.props.data.axis.map(i => {
                                    return <Line key={i.id} type="monotone" dataKey={i.slug} stroke={i.color} activeDot={{ r: 8 }} />
                                })}
                        </LineChart>
                    </Segment>
                </div>
            </div>
        )
    }
}

ShipSumChart.propTypes = {
    data: PropTypes.shape({
        axis: PropTypes.array.isRequired,
        lines: PropTypes.array.isRequired
    })
};

export default ShipSumChart


// WEBPACK FOOTER //
// ./src/components/reports/components/shipSumChart.js